import React, { useEffect } from 'react';
import { Card, CardContent, Chip, Typography, Tooltip, IconButton } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { BuildingIDProps } from '../atoms-types/chargers';
import { powerAtom, Power } from '../atoms-types/power';
import { useAtom } from 'jotai';

export const PowerCard: React.FC<BuildingIDProps> = ({ BuildingID }) => {
  const [powerData] = useAtom(powerAtom);

  if (!BuildingID) return null;

  // Get the latest power data for this building
  const buildingPowerData = powerData[BuildingID?.toLowerCase()];
  const latestPowerData = buildingPowerData && buildingPowerData.length > 0 
    ? buildingPowerData[buildingPowerData.length - 1] 
    : null;

  if (!latestPowerData) {
    return <Typography>Loading power data for {BuildingID}...</Typography>;
  }

  const tooltipContent = (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <Typography variant="body2">PhA: {(Number(latestPowerData.PhA) || 0).toFixed(4)}</Typography>
      <Typography variant="body2">PhB: {(Number(latestPowerData.PhB) || 0).toFixed(4)}</Typography>
      <Typography variant="body2">PhC: {(Number(latestPowerData.PhC) || 0).toFixed(4)}</Typography>
      <Typography variant="body2">Solar: {(Number(latestPowerData.Solar) || 0).toFixed(4)}</Typography>
      <Typography variant="body2">Load: {(Number(latestPowerData.Load) || 0).toFixed(4)}</Typography>
      <Typography variant="body2">Demand: {(Number(latestPowerData.Demand) || 0).toFixed(4)}</Typography>
      <Typography variant="body2">DayPeak: {(Number(latestPowerData.DayPeak) || 0).toFixed(4)}</Typography>
    </div>
  );

  return (
    <Card>
      <CardContent>
        <Typography gutterBottom variant="h5" component="div" sx={{ color: 'text.primary' }}>
          {BuildingID}
        </Typography>
        <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: '20px', alignItems: 'center' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <Typography>Grid</Typography>
            <Chip label={`${(Number(latestPowerData.Grid) || 0).toFixed(4)}`} sx={{ backgroundColor: 'secondary.light', color: 'primary.contrastText' }} />
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <Typography>Import</Typography>
            <Chip label={`${(Number(latestPowerData.DaykWhImport) || 0).toFixed(4)}`} sx={{  backgroundColor: 'secondary.light', color: 'primary.contrastText' }} />
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <Typography>Export</Typography>
            <Chip label={`${(Number(latestPowerData.DaykWhExport) || 0).toFixed(4)}`} sx={{ backgroundColor: 'secondary.light', color: 'primary.contrastText' }} />
          </div>
          <Tooltip title={tooltipContent} placement="top" arrow>
            <IconButton size="small" sx={{ marginLeft: 'auto', color: 'primary.main' }}>
              <InfoOutlinedIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </div>
      </CardContent>
    </Card>
  );
};

